// from the payment gate, the user should be redirected on the payment status validation screen
var PAYMENT_CHECK_SCREEN_ROUTE = "validate-payment";
export var getPaymentCheckScreenRoute = function getPaymentCheckScreenRoute() {
  var windowUrl = window.location.href;
  var url = new URL(windowUrl);
  var splitPathname = url.pathname.split('/'); // omit last segment (form)

  splitPathname.splice(-1, 1);
  var pathname = splitPathname.join('/');
  var newUrl = "".concat(url.protocol, "//").concat(url.host).concat(pathname, "/").concat(PAYMENT_CHECK_SCREEN_ROUTE, "/").concat(url.search);
  return newUrl;
};